module.exports = __webpack_public_path__ + "img/lr.bbca6561.svg";